import HTMLTemplate from './template.html'
import './styles.scss'

export const Sprite = (() => {
    var vueComponent = {
        data() {
            return {}
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-sprite')

    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})();